import { render, staticRenderFns } from "./CustomIframePopup.vue?vue&type=template&id=58523c84&scoped=true"
import script from "./CustomIframePopup.vue?vue&type=script&lang=js"
export * from "./CustomIframePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58523c84",
  null
  
)

export default component.exports